// api/baseApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "@/utils/customBaseQuery";

export const baseApi = createApi({
  baseQuery: baseQueryWithInterceptor,
  reducerPath: "api",
  endpoints: () => ({}),
  tagTypes: [
    "CompOff",
    "leaveApproveApi",
    "YearList",
    "LeaveDeatils",
    "LeaveSummary",
    "LeaveChart",
    "Transaction",
    "LeaveApprovePending",
    "LeaveApproveCompleted",
    "LeaveCalender",
    "LeaveHistory",
    "LeaveCancel",
    "RestrictedHoliday",
    "empLeaveBalance",
    "LeaveBalanceImport",
    "LeaveGranter",
    "LeaveSchemeDetails",
    "LeaveSchemeDetailsEmp",
    "LeaveReport",
    "LeaveTypeCategory",
    "LeaveScheme",
    "LockAttendace",

    "MailTemplates",
    "gradeDetails",
    "MyTeam",
    "Movement",
    "OtherTeam",
    "OldEmp",
    "RepManagerPending",
    "RepManagerCompleted",
    "RepManagerCompletedTwo",
    "BuddyFeedBack",
    "BuddyInfo",
    "CandidateOnBoarding",
    "InductionSchedule",
    "WelcomeAboard",
    "EmailIdCreationPending",
    "EmailIdCreationApproved",

    // onboarding
    "DayZeroData",
    "DocumentView",
    "EmailIdCreationOnBoarding",
    "EmailIdCreationApproved",
    "SeatingReadinessCardRequestPending",
    "SeatingReadinessCardRequestAccept",
    "TodayDateJoining",

    "EVENTS",
    "Login",
    "BIRTHDAYS",
    "ANNIVERSARY",
    "CandidateSeatingPending",
    "CandidateSeatingApproved",
    "CHANGEPASSWORD",
    "ChatBot",
    "CommonAPI",
    "LIST",
    "FetchCommonApi",
    "CommonSettings",
    "dynamicForm",
    "EmployeeList",
    "SubOrganization",
    "IDCard",
    "ReportingManager",
    "BulkUpload",
    "Organization",
    "Roles",
    "Recruiter",
    "AccessType",
    "RoleType",
    "helpDeskSpocApi",
    "myRequest",
    "raiseTicket",
    "myTeams",
    "holidays",
    "CompanyPolicy",
    "EmployeeDocuments",
    "EmployeePeople",
    "MyTeamPepole",
    "GraphicsTeam",
    "ConfirmedProbationHr",
    "currentProbationHr",
    "SavedCurrentProbationHr",
    "DeemedProbationHr",
    "DeemedProbationHr",
    "SavedExtendedProbationHr",
    "ExtendedProbationHr",
    "ConfirmedProbation",
    "CurrentProbation",
    "SavedCurrentProbation",
    "ExtendedProbation",
    "accountInformation",
    "hrAccountInformation",
    "basicDetails",
    "hrBasicDetails",
    "contactDetails",
    "hrContactDetails",
    "hrEducationDetails",
    "educationDetails",
    "hrExperienceDetails",
    "experienceDetails",
    "hrFamilyDetails",
    "familyDetails",
    "fetchImage",
    "followUp",
    "hrHrInfo",
    "hrInformation",
    "documentDetails",
    "hrDocumentDetails",
    "profileDetails",
    "hrProfileDetails",
    "workingInformation",
    "hrWorkingInformation",
    "EMPSEP",
    "REPO_SEP",
    "Approvals",
    "hrHelpdeskReport",
    "graph",
    "movementGraph",
    "EVENTS",
    "Login",
    "BIRTHDAYS",
    "ANNIVERSARY",
    "CandidateSeatingPending",
    "CandidateSeatingApproved",
    "CHANGEPASSWORD",
    "ChatBot",
    "CommonAPI",
    "LIST",
    "FetchCommonApi",
    "CommonSettings",
    "dynamicForm",
    "EmployeeList",
    "SubOrganization",
    "IDCard",
    "ReportingManager",
    "BulkUpload",
    "Organization",
    "Roles",
    "Recruiter",
    "AccessType",
    "RoleType",
    "helpDeskSpocApi",
    "myRequest",
    "raiseTicket",
    "myTeams",
    "holidays",
    "CompanyPolicy",
    "EmployeeDocuments",
    "EmployeePeople",
    "EmployeePeopleList",
    "MyTeamPepole",
    "GraphicsTeam",
    "ConfirmedProbationHr",
    "currentProbationHr",
    "SavedCurrentProbationHr",
    "DeemedProbationHr",
    "DeemedProbationHr",
    "SavedExtendedProbationHr",
    "ExtendedProbationHr",
    "ConfirmedProbation",
    "CurrentProbation",
    "SavedCurrentProbation",
    "ExtendedProbation",
    "accountInformation",
    "hrAccountInformation",
    "basicDetails",
    "hrBasicDetails",
    "contactDetails",
    "hrContactDetails",
    "hrEducationDetails",
    "educationDetails",
    "hrExperienceDetails",
    "experienceDetails",
    "hrFamilyDetails",
    "familyDetails",
    "fetchImage",
    "followUp",
    "hrHrInfo",
    "hrInformation",
    "documentDetails",
    "hrDocumentDetails",
    "profileDetails",
    "hrProfileDetails",
    "workingInformation",
    "hrWorkingInformation",
    "EMPSEP",
    "REPO_SEP",
    "Approvals",
    "hrHelpdeskReport",
    "graph",
    "movementGraph",

    // Attendance
    "AttendanceReport",
    "Calendar",
    "EmployeeTracker",
    "Muster",
    "Regularization",
    "AbsentPresntList",
    "QuickAdd",
    "AbsentPresnt",
    "AdminAttendanceReport",
    "AdminAttendanceTracker",
    "AttendanceRegularization",
    "LeaveApplication",
    "AttendanceMuster",
    "Override",
    "OverrideHistory",
    "OnsiteAttendance",
    "ShiftRoster",
    "DayType",
    "ShiftRosterImport",
    "WeekendPolicy",
    "shiftMaster",
    "shiftType",

    // Payroll
    "ArrearsList",
    "CTCBreak",
    "FbpEmployee",
    "MasterData",
    "RangeData",
    "EmpList",
    "ReportList",
    "HeaderList",
    "LOAN",
    "Lwf",
    "LwfReportData",
    "monthlyImport",
    "ComponentData",
    "AttendanceDate",
    "LockMonthData",
    "payrollEsic",
    "EsicReportData",
    "paysheetPayrollStatus",
    "TaxsheetData",
    "payslip",
    "download",
    "payslipMonth",
    "ReportList",
    "payrollPfLogic",
    "payrollPfLogicEmployees",
    "PfReportData",
    "PtListData",
    "PtReportData",
    "MinimumWagesList",
    "ReleaseEmp",
    "ReimReportData",
    "ClaimsData",
    "ApprovedData",
    "ytdReportList",
    "VPF",
    "Tds",
    "Regimies",
    "taxType",
    "TdsReportData",
    "ClaimsData",
    "ApprovedData",
    "reportpay",
    "itdReport",
    "itdEmployees",
    "itdFinYear",
    "ReleaseList",
    "payrollPaysheetList",
    "exitPayrollPaysheetList",
    "payrollPaysheetHeader",
    "exitPayrollPaysheetHeader",
    "ReimReleaseList",
    "ItdCreateList",
    "ItdReleaseList",
    "ArrearsTableHeader",
    "FBAList",
  
    "PoiIndex",
    "FnfData",
  
    

    //Leave
    "LeaveApply",
    "EmpLeaveDetails",
    "Leave Balance",
    "LeaveType",
    "LeaveCheck",

    //Settings
    "AdminHoliday",
    "SettingsFormData",
    "SettingFormValue",
    "Get Company Policy",
    "Get Policy Category",
    "Menu",
    "Organization",
    "Submenu",
    "RolesAndPermision",
    "Get Document Table",
    "Get Category",

    //iiy
    "EMPACTIVITY",
    "EMPIDEA",
    "courseCategory",
    "course",
    "ideaCategory",
    "TeamActivityReport",

    // employee    list
    "Export",

    // Add all other tag types here
    "ChatBotNew",
    "WebSign",
    "ASSETS",
  ],
});
